// extracted by mini-css-extract-plugin
export var areaSelectionButton = "area-breadcrumbs-row-module--areaSelectionButton--81eee";
export var breadcrumbs = "area-breadcrumbs-row-module--breadcrumbs--95078";
export var container = "area-breadcrumbs-row-module--container--8ed97";
export var link = "area-breadcrumbs-row-module--link--849b9";
export var rightIcon = "area-breadcrumbs-row-module--rightIcon--167d6";